const Modal = ({ onClose, children }) => {
    return (
        <div className="success_bg" onClick={onClose}>
            <div
                className="success_content"
                onClick={(e) => e.stopPropagation()}
                style={{
                    maxWidth: "50vw",
                    width: "max-content",
                    minWidth: "10rem",
                    height: "max-content",
                }}
            >
                {children}
            </div>
        </div>
    );
};

export default Modal;
